import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { HeadlineXL } from 'atoms/typography';

import { RivalryStatus_rivalryStatus } from './__generated__/index.graphql';

const Root = styled(Horizontal).attrs({ center: true })`
  cursor: default;
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

type Props = {
  status?: Omit<RivalryStatus_rivalryStatus, '__typename'> | null;
};
export const RivalryStatus = ({ status }: Props) => {
  if (!status?.emoji) {
    return null;
  }

  return (
    <Root>
      <Tooltip title={status.title}>
        <HeadlineXL as="span">{status.emoji}</HeadlineXL>
      </Tooltip>
    </Root>
  );
};

RivalryStatus.fragments = {
  rivalryStatus: gql`
    fragment RivalryStatus_rivalryStatus on RivalryStatus {
      emoji
      title
    }
  ` as TypedDocumentNode<RivalryStatus_rivalryStatus>,
};
